export default "__VITE_PUBLIC_ASSET__dc50201a__"